"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Comparison = void 0;
var _react = _interopRequireWildcard(require("react"));
var _common = require("b2b-components/theme/components/Comparison/common");
var _debounce = require("b2b-components/utils/debounce");
var _mediaQuery = require("b2b-components/utils/mediaQuery");
var _Comparison = require("./Comparison");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ComparisonContainer = _ref => {
  let {
    items,
    areDifferencesHighlighted,
    stickyRowTop = 0,
    emptyColumnText,
    className
  } = _ref;
  const [slideIndex, setSlideIndex] = (0, _react.useState)(0);
  const numberOfItems = items.length;
  const visibleColumns = !_mediaQuery.isDesktop ? _common.MIN_NUMBER_OF_COLUMNS_VISIBLE : numberOfItems === 3 ? 3 : numberOfItems < 3 ? _common.MIN_NUMBER_OF_COLUMNS_VISIBLE : _common.MAX_NUMBER_OF_COLUMNS_VISIBLE;
  const maxIndex = numberOfItems < visibleColumns ? 0 : numberOfItems - visibleColumns;
  const headerRowRef = (0, _react.useRef)(null);
  const [isStickyRowVisible, setIsStickyRowVisible] = (0, _react.useState)(false);
  const handleStickyVisibility = (0, _debounce.debounce)(() => {
    if (headerRowRef.current) {
      const visibilityPoint = headerRowRef.current.getBoundingClientRect().y - stickyRowTop;
      setIsStickyRowVisible(visibilityPoint < 0);
    }
  }, 10);
  (0, _react.useEffect)(() => {
    window.addEventListener('scroll', handleStickyVisibility, false);
    window.addEventListener('resize', handleStickyVisibility, false);
    return () => {
      window.removeEventListener('scroll', handleStickyVisibility, false);
      window.removeEventListener('resize', handleStickyVisibility, false);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Comparison.Comparison, {
    items: items,
    areDifferencesHighlighted: areDifferencesHighlighted,
    stickyRowTop: stickyRowTop,
    onSlideChange: setSlideIndex,
    slideIndex: slideIndex,
    maxSlideIndex: maxIndex,
    isStickyRowVisible: isStickyRowVisible,
    emptyColumnText: emptyColumnText,
    ref: headerRowRef,
    className: className,
    visibleColumns: visibleColumns,
    numberOfItems: numberOfItems
  });
};
exports.Comparison = ComparisonContainer;
//# sourceMappingURL=ComparisonContainer.js.map